import { useEffect, useState } from 'react';
import { noop } from 'lodash';

export const useTabVisibility = ({ onVisible = noop, onHidden = noop } = {}) => {
    const [isVisible, setIsVisible] = useState(document.visibilityState === 'visible');

    useEffect(() => {
        const handleVisibilityChange = () => {
            const visible = document.visibilityState === 'visible';
            setIsVisible(visible);
            if (visible) {
                onVisible();
            } else {
                onHidden();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        handleVisibilityChange();

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [onVisible, onHidden]);

    return isVisible;
};
